// Environments where the browser SDK samples everything and logs verbosely.
// Deployed environments (dev, prod) use the reduced rates below.
const LOCAL_ENVIRONMENTS = new Set(['local', 'development']);

const UNSAMPLED_PATTERNS = ['favicon', 'robots.txt', '/static/', '/media/'];

export function isLocalEnvironment(environment) {
    return LOCAL_ENVIRONMENTS.has(environment);
}

// The environment comes from Django at request time, not from the webpack
// build: one image is deployed to every environment, so a build-time value
// would be wrong for all but one of them.
export function resolveSentryEnvironment(clientConfig) {
    return (clientConfig && clientConfig.environment) || 'development';
}

export function createTracesSampler(environment) {
    const isLocal = isLocalEnvironment(environment);

    return function tracesSampler(samplingContext) {
        const name = (samplingContext.name || '').toLowerCase();

        if (UNSAMPLED_PATTERNS.some((pattern) => name.includes(pattern))) {
            return 0.0;
        }

        // Keep a trace whole: follow the upstream decision when there is one.
        if (typeof samplingContext.parentSampled === 'boolean') {
            return samplingContext.parentSampled ? 1.0 : 0.0;
        }

        if (isLocal) {
            return 1.0;
        }

        if (name.includes('/admin/')) {
            return 0.5;
        }

        if (name.includes('/api/')) {
            return 0.8;
        }

        return 0.6;
    };
}
